const INTEGRATION_TYPES = {
  AGENT: "agent",
  PLAYER: "player",
  THIRDPARTY: "thirdparty",
};

export { INTEGRATION_TYPES };
